export default "__VITE_PUBLIC_ASSET__421707ef__"